import React from "react";

const OutstationCabTerms = () => {
  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">Other Terms</h2>
      <ul className="list-group list-group-flush">
        <li className="list-group-item">
          <strong>Fare Inclusions:</strong>
          <ul>
            <li>Vehicle and fuel charges are included in the fare.</li>
            <li>Driver night charges, stay, food, and allowance are included.</li>
            <li>Toll charges and state taxes are included.</li>
            <li>
              For round trip bookings, all local sightseeing within the mentioned
              cities is covered.
            </li>
          </ul>
        </li>

        <li className="list-group-item">
          <strong>GST and Other Taxes:</strong> 5% GST is applicable on the total
          fare and will be charged additionally.
        </li>

        <li className="list-group-item">
          <strong>Kilometer Calculation:</strong>
          <ul>
            <li>
              For <strong>round trips</strong>, kilometers will be calculated from
              the <strong>pickup location to pickup location</strong>.
            </li>
            <li>
              For <strong>one-way trips</strong>, only one pickup and drop are
              included. Additional pickup/drop en route will cost ₹250 per stop.
            </li>
            <li>
              Included kilometers start from the pickup location and end at the
              same (round trip only).
            </li>
          </ul>
        </li>

        <li className="list-group-item">
          <strong>Air Conditioning:</strong> AC will be turned off in hilly areas to
          ensure vehicle performance and safety.
        </li>

        <li className="list-group-item">
          <strong>Parking Charges:</strong> Parking charges (if any) are not
          included and are to be paid directly by the customer.
        </li>

        <li className="list-group-item">
          <strong>Permits & Entry Charges:</strong>
          <ul>
            <li>
              Rohtang Pass visit is not included. A special permit is required and
              chargeable.
            </li>
            <li>
              Monument entry fees, sightseeing tickets, or special area permits are
              not included.
            </li>
          </ul>
        </li>

        {/* <li className="list-group-item">
          <strong>Driver Working Hours:</strong> Driver is available for a maximum
          of 12 hours/day. Additional hours may incur extra charges.
        </li> */}

        <li className="list-group-item">
          <strong>Vehicle Usage Limitations:</strong> Use of vehicle is restricted
          to the planned itinerary. Any deviation may attract extra charges.
        </li>

        <li className="list-group-item">
          <strong>Luggage Limit:</strong> Please follow standard luggage limits as
          per vehicle type. Excess luggage may not be allowed for safety.
        </li>

        <li className="list-group-item">
          <strong>Delays and Waiting Charges:</strong> First 30 minutes waiting is
          free. Further delays may attract additional charges.
        </li>

        <li className="list-group-item">
          <strong>Trip Modifications:</strong> Any changes in plan or route must be
          informed in advance and may affect the fare.
        </li>

        <li className="list-group-item">
          <strong>Cancellation and Refunds:</strong> Please refer to our Cancellation
          Policy for applicable deductions.
        </li>
      </ul>
    </div>
  );
};

export default OutstationCabTerms;
